import React from "react";

const CoachInfo = (props) => {
  return (
    <div className="card">
      <h3>Coaching Informationn</h3>
      <div className="card-body">
        {props.data?.uncommonNewData?.clubCoachName && (
          <div class="datas">
            <p>Club Coach Name:</p>
            <del>{props.data?.uncommonOldData?.clubCoachName}</del>
            <span>{props.data?.uncommonNewData?.clubCoachName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.clubCoachPhone && (
          <div class="datas">
            <p>Club Coach Phone:</p>
            <del>{props.data?.uncommonOldData?.clubCoachPhone}</del>
            <span>{props.data?.uncommonNewData?.clubCoachPhone}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.clubCoachEmail && (
          <div class="datas">
            <p>Club Coach Email:</p>
            <del>{props.data?.uncommonOldData?.clubCoachEmail}</del>
            <span>{props.data?.uncommonNewData?.clubCoachEmail}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.highSchoolCoachName && (
          <div class="datas">
            <p>High School Coach Name:</p>
            <del>{props.data?.uncommonOldData?.highSchoolCoachName}</del>
            <span>{props.data?.uncommonNewData?.highSchoolCoachName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.highSchoolCoachPhone && (
          <div class="datas">
            <p>High School Coach Phone:</p>
            <del>{props.data?.uncommonOldData?.highSchoolCoachPhone}</del>
            <span>{props.data?.uncommonNewData?.highSchoolCoachPhone}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.highSchoolCoachEmail && (
          <div class="datas">
            <p>High School Coach Email:</p>
            <del>{props.data?.uncommonOldData?.highSchoolCoachEmail}</del>
            <span>{props.data?.uncommonNewData?.highSchoolCoachEmail}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.hittingCoachName && (
          <div class="datas">
            <p>Hitting Coach Name:</p>
            <del>{props.data?.uncommonOldData?.hittingCoachName}</del>
            <span>{props.data?.uncommonNewData?.hittingCoachName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.hittingCoachPhone && (
          <div class="datas">
            <p>Hitting Coach Phone:</p>
            <del>{props.data?.uncommonOldData?.hittingCoachPhone}</del>
            <span>{props.data?.uncommonNewData?.hittingCoachPhone}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.hittingCoachEmail && (
          <div class="datas">
            <p>Hitting Coach Email:</p>
            <del>{props.data?.uncommonOldData?.hittingCoachEmail}</del>
            <span>{props.data?.uncommonNewData?.hittingCoachEmail}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.pitchingCoachName && (
          <div class="datas">
            <p>Pitching Coach Name:</p>
            <del>{props.data?.uncommonOldData?.pitchingCoachName}</del>
            <span>{props.data?.uncommonNewData?.pitchingCoachName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.pitchingCoachPhone && (
          <div class="datas">
            <p>Pitching Coach Phone:</p>
            <del>{props.data?.uncommonOldData?.pitchingCoachPhone}</del>
            <span>{props.data?.uncommonNewData?.pitchingCoachPhone}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.pitchingCoachEmail && (
          <div class="datas">
            <p>Pitching Coach Email:</p>
            <del>{props.data?.uncommonOldData?.pitchingCoachEmail}</del>
            <span>{props.data?.uncommonNewData?.pitchingCoachEmail}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.catchingCoachName && (
          <div class="datas">
            <p>Catching Coach Name:</p>
            <del>{props.data?.uncommonOldData?.catchingCoachName}</del>
            <span>{props.data?.uncommonNewData?.catchingCoachName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.catchingCoachPhone && (
          <div class="datas">
            <p>Catching Coach Phone:</p>
            <del>{props.data?.uncommonOldData?.catchingCoachPhone}</del>
            <span>{props.data?.uncommonNewData?.catchingCoachPhone}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.catchingCoachEmail && (
          <div class="datas">
            <p>Catching Coach Email:</p>
            <del>{props.data?.uncommonOldData?.catchingCoachEmail}</del>
            <span>{props.data?.uncommonNewData?.catchingCoachEmail}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.specialtyCoachName && (
          <div class="datas">
            <p>Specialty Coach Name:</p>
            <del>{props.data?.uncommonOldData?.specialtyCoachName}</del>
            <span>{props.data?.uncommonNewData?.specialtyCoachName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.specialtyCoachFocus && (
          <div class="datas">
            <p>Specialty Coach Focus:</p>
            <del>{props.data?.uncommonOldData?.specialtyCoachFocus}</del>
            <span>{props.data?.uncommonNewData?.specialtyCoachFocus}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.specialtyCoachPhone && (
          <div class="datas">
            <p>Specialty Coach Phone:</p>
            <del>{props.data?.uncommonOldData?.specialtyCoachPhone}</del>
            <span>{props.data?.uncommonNewData?.specialtyCoachPhone}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.specialtyCoachEmail && (
          <div class="datas">
            <p>Specialty Coach Email:</p>
            <del>{props.data?.uncommonOldData?.specialtyCoachEmail}</del>
            <span>{props.data?.uncommonNewData?.specialtyCoachEmail}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CoachInfo;
